export { default } from './RevealOnLoad';
